import { eventChannel } from 'redux-saga'
import { onSnapshot } from 'firebase/firestore'
import type { Query, DocumentReference, DocumentData } from 'firebase/firestore'

type SnapshotEvent =
    | { type: 'data'; snapshot: any }
    | { type: 'error'; error: any }

export function createSnapshotChannel(queryOrRef: Query<DocumentData> | DocumentReference<DocumentData>) {
    return eventChannel<SnapshotEvent>(emit => {
        const unsub = onSnapshot(
            queryOrRef as any,
            (snapshot: any) => emit({ type: 'data', snapshot }),
            (error: any) => emit({ type: 'error', error })
        )
        return unsub
    })
}
